import React from 'react'

import IconChecked from '_icons/IconChecked'
import IconUnChecked from '_icons/IconUnChecked'

import './styles.scss'

const Checkbox = ({ checked, name, label, onChange }) => {
  return (
    <label className="ds-checkbox">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={() => onChange({ name, currentCheck: checked })}
        style={{ display: 'none' }}
      />
      <Choose>
        <When condition={checked}>
          <IconChecked />
        </When>
        <Otherwise>
          <IconUnChecked />
        </Otherwise>
      </Choose>
      <span>{label}</span>
    </label>
  )
}

export default Checkbox
